package music.jammers.client.shared.component.member.info.legend.presentation.viewmodel

import kotlinx.coroutines.flow.MutableStateFlow
import music.jammers.client.shared.component.BaseViewModel
import music.limasoul.client.shared.navigation.Navigation
import music.limasoul.client.shared.navigation.Router

class MemberInfoLegendViewModel(
    private val router: Router,
) : BaseViewModel() {

    private val _state = MutableStateFlow(false)

    internal fun onReady(extended: Boolean) {
        _state.value = extended
    }

    internal fun onInfoButtonClicked() {
        router.navigateTo(Navigation.EventTrack.MemberDialog(_state.value))
    }
}